import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Loan = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <path
        d="M38.9651 16.726V27.026C38.9651 33.186 35.4452 35.8259 30.1652 35.8259H12.5851C11.6851 35.8259 10.8251 35.746 10.0251 35.566C9.52515 35.486 9.04516 35.346 8.60516 35.186C5.60516 34.066 3.78516 31.466 3.78516 27.026V16.726C3.78516 10.566 7.30514 7.92603 12.5851 7.92603H30.1652C34.6452 7.92603 37.8652 9.82602 38.7252 14.166C38.8652 14.966 38.9651 15.786 38.9651 16.726Z"
        stroke="#1E88E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M44.9654 22.726V33.026C44.9654 39.186 41.4454 41.8259 36.1654 41.8259H18.5854C17.1054 41.8259 15.7654 41.626 14.6054 41.186C12.2254 40.306 10.6054 38.486 10.0254 35.566C10.8254 35.746 11.6854 35.8259 12.5854 35.8259H30.1654C35.4454 35.8259 38.9654 33.186 38.9654 27.026V16.726C38.9654 15.786 38.8854 14.946 38.7254 14.166C42.5254 14.966 44.9654 17.646 44.9654 22.726Z"
        stroke="#1E88E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.366 27.166C24.282 27.166 26.646 24.802 26.646 21.886C26.646 18.9699 24.282 16.606 21.366 16.606C18.4499 16.606 16.0859 18.9699 16.0859 21.886C16.0859 24.802 18.4499 27.166 21.366 27.166Z"
        stroke="#1E88E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.92578 17.4858V26.2859"
        stroke="#1E88E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M32.8047 17.4858V26.2859"
        stroke="#1E88E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Loan.displayName = 'Loan';
